<template>
  <div>
    <b-container>
      <div v-if="isLoading" class="d-flex justify-content-center mt-5">
        <b-spinner label="Loading..." variant="dark" />
      </div>

      <div v-else class="justify-content-center">
        <base-back-to-previous-button
          class="my-u4 btn__previous-page"
          :fallback="fallbackRoute"
          :show-arrow="1"
        />

        <b-col v-if="$_orderPaymentObserverMixin_order">
          <b-row class="my-4">
            <b-col>
              <h4>
                <b>Order No: {{ $_orderPaymentObserverMixin_order.order_no }}</b>
              </h4>
            </b-col>
          </b-row>

          <b-row class="order-row">
            <b-col cols="12" md="2" class="mb-3">
              <div class="detail-title text__totle-price">Total :</div>
              <div>{{ $_formatPrice($_orderPaymentObserverMixin_order.total_amount) }} THB</div>
            </b-col>
            <b-col cols="12" md="3" class="mb-3">
              <div class="detail-title text__payment-method">Payment method :</div>
              <div>
                {{
                  $_orderPaymentObserverMixin_order.latest_payment
                    ? $_formatPaymentMethod(
                        $_orderPaymentObserverMixin_order.latest_payment.payment_method
                      )
                    : '-'
                }}
              </div></b-col
            >
            <b-col cols="12" md="3" class="mb-3">
              <div class="detail-title text__payment-date">Payment date :</div>
              <div>
                {{
                  formatedDatetime(
                    $_orderPaymentObserverMixin_order.updated_at,
                    'MMM D, YYYY hh:mm a'
                  )
                }}
              </div>
            </b-col>
            <b-col cols="12" md="3" class="mb-3">
              <div class="detail-title text__payment-status">Status :</div>
              <div>
                <b-badge
                  pill
                  :variant="badgeStatusVariant(orderDisplayStatus)"
                  class="py-1 order__status"
                  :class="badgeStatusTextVariant(orderDisplayStatus)"
                >
                  <span class="order__status-text">{{ orderDisplayStatus }}</span>
                </b-badge>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-table
              v-if="displayOrderItems.length"
              ref="item_table"
              head-variant="null"
              table-variant="null"
              :items="displayOrderItems"
              :fields="fields"
              class="mt-3 mx-3 item_table"
              tbody-tr-class="row__order-item"
            >
              <template #cell(item_name)="data">
                <span class="text__mc-title">{{ data.value }}</span>
              </template>
              <template #cell(mode)="data">
                <span class="text__mc-type text-dark">{{ displayMode(data.value) }} </span>
              </template>
              <template #cell(display_price)="data">
                <span class="text__price text-primary"> {{ $_formatPrice(data.value) }} THB </span>
              </template>
              <template #custom-foot>
                <b-tr class="text-footer">
                  <b-th></b-th>
                  <b-th>Total</b-th>
                  <b-th class="text-primary">
                    {{ $_formatPrice($_orderPaymentObserverMixin_order.total_amount) }} THB</b-th
                  >
                </b-tr>
              </template>
            </b-table>
          </b-row>
        </b-col>
      </div>
    </b-container>

    <qr-payment-modal
      v-if="
        $_orderPaymentObserverMixin_order &&
        $_orderPaymentObserverMixin_order.status === 'PENDING' &&
        $_orderPaymentObserverMixin_order.latest_payment &&
        $_orderPaymentObserverMixin_order.latest_payment.payment_method === 'QR_PAYMENT'
      "
      ref="qrPaymentModal"
      :order="$_orderPaymentObserverMixin_order"
      :payment="$_orderPaymentObserverMixin_order.latest_payment"
    />
  </div>
</template>

<script>
import BaseBackToPreviousButton from '@/components/base-components/BaseBackToPreviousButton';
import Order from '@/models/Order';
import OrderItem from '@/models/OrderItem';
import { datetimeMixin } from '@/mixins/datetimeMixin';
import { formatPriceMixin } from '@/mixins/formatPriceMixin';
import QrPaymentModal from '@/components/Payment/QrPaymentModal.vue';
import { orderPaymentObserverMixin } from '@/mixins/orderPaymentObserverMixin';
import { formatPaymentMethodMixin } from '@/mixins/formatPaymentMethodMixin';
// import Payment from '@/models/Payment';

export default {
  components: {
    BaseBackToPreviousButton,
    QrPaymentModal
  },
  mixins: [datetimeMixin, formatPaymentMethodMixin, formatPriceMixin, orderPaymentObserverMixin],

  data() {
    return {
      isLoading: false,
      pullingOrderInterval: null,
      fields: [
        { key: 'item_name', label: 'Item', thClass: 'bg-white', thStyle: { width: '60%' } },
        { key: 'mode', label: 'Type', thClass: 'bg-white', tfStyle: { width: '60%' } },
        { key: 'display_price', label: 'Price', thClass: 'bg-white' }
      ]
    };
  },
  computed: {
    fallbackRoute() {
      return {
        name: 'purchase'
      };
    },
    orderId() {
      return parseInt(this.$route.params.orderId);
    },
    orderDisplayStatus() {
      let status = this.$_orderPaymentObserverMixin_order?.status;

      if (
        this.$_orderPaymentObserverMixin_order?.latest_payment &&
        this.$_datetimeMixin_isLessThanNow(
          new Date(this.$_orderPaymentObserverMixin_order.latest_payment.due_date)
        )
      ) {
        status = 'EXPIRED';
      }

      if (this.$_orderPaymentObserverMixin_order?.latest_payment?.status == 'SUCCESS') {
        status = 'COMPLETED'; //overwrite status if payment is success
      }

      return status;
    },
    displayOrderItems() {
      return OrderItem.query()
        .with('learning_unit_option.learning_unit')
        .where('order_id', this.orderId)
        .get()
        .map((item) => {
          return {
            id: item.id,
            item_name: item.learning_unit_option.learning_unit.name,
            mode: `${item.learning_unit_option.mode}_${item.learning_unit_option.option_type}`,
            display_price: item.price_discount !== null ? item.price_discount : item.price
          };
        });
    }
  },

  created() {
    this.orderPaymentObserverMixin_event.addEventListener('order-paid', this.onOrderPaid);
  },

  async mounted() {
    this.isLoading = true;

    this.orderPaymentObserverMixin_orderId = this.orderId;

    await Promise.all([
      Order.api().fetchOrder(this.orderId),
      OrderItem.api().fetchItems({ order_id: this.orderId })
    ]);

    this.isLoading = false;

    if (
      this.$_orderPaymentObserverMixin_order.status === 'PENDING' &&
      this.$_orderPaymentObserverMixin_order.payments.every(
        (payment) => payment.status === 'PENDING'
      )
    ) {
      this.$_orderPaymentObserverMixin_startOrderPulling();

      if (this.$route.query?.openModal) {
        this.openModalPayment();
      }
    }
  },

  beforeDestroy() {
    this.orderPaymentObserverMixin_event.removeEventListener('order-paid', this.onOrderPaid);
  },

  methods: {
    displayMode(mode) {
      const key = {
        VERIFY_ENTRY: 'Verify',
        LEARN_VERIFY_ENTRY: 'Verify + Learn',
        VERIFY_QUOTA: 'Quota',
        LEARN_VERIFY_QUOTA: 'Learn + Quota'
      };

      return key[mode];
    },

    badgeStatusVariant(status) {
      let variant;

      switch (status) {
        case 'PENDING':
          variant = 'neutral-warning';
          break;

        case 'CANCELLED':
          variant = 'neutral-danger';
          break;

        case 'COMPLETED':
          variant = 'neutral-success';
          break;

        case 'EXPIRED':
          variant = 'secondary';
          break;

        default:
          variant = '';
          break;
      }

      return variant;
    },

    badgeStatusTextVariant(status) {
      let variant;

      switch (status) {
        case 'PENDING':
          variant = 'text-warning';
          break;

        case 'CANCELLED':
          variant = 'text-danger';
          break;

        case 'COMPLETED':
          variant = 'text-success';
          break;

        case 'EXPIRED':
          variant = '';
          break;

        default:
          variant = '';
          break;
      }

      return variant;
    },

    openModalPayment() {
      if (!this.payment) return;

      switch (this.payment.payment_method) {
        case 'QR_PAYMENT':
          this.$refs.qrPaymentModal?.open();
          break;

        default:
          break;
      }
    },

    onOrderPaid(event) {
      console.log(event);

      this.$router.push({
        name: 'payment-success',
        params: { orderId: event.detail.id }
      });
    }
  }
};
</script>

<style lang="scss">
.text__mc-title {
  width: 1000px;
}
.order-row {
  width: 100%;
}
.detail-title {
  opacity: 0.7;
}
.text__price {
  text: primary;
}
.text-footer th {
  border-bottom: 0px;
}

.item_table.table th,
.item_table.table td {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important;
}

.order__status {
  width: 100%;
  max-width: fit-content;
  height: auto;

  .order__status-text {
    white-space: break-spaces;
  }
}
</style>
